
import { mapState } from 'vuex'

export default {
  props: {
    headline: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState(['order'])
  },
  data() {
    return {
      amount: null,
      selected: null,
      customApplied: false,
      tips: [
        {
          title: '15%',
          value: 0.15
        },
        {
          title: '20%',
          value: 0.2
        },
        {
          title: '25%',
          value: 0.25
        },
        {
          title: 'Custom',
          value: 'custom'
        }
      ],
      showCustom: false
    }
  },
  mounted() {
    this.tips.map((t) => {
      if (typeof t.value !== 'string') {
        if (
          parseFloat((this.order.totals.subtotal * t.value).toFixed(2)) ==
          this.order.totals.tip
        ) {
          this.selected = t.value
        }
      }
    })
    if (this.selected == null && this.order.totals.tip > 0) {
      this.selected = 'custom'
      this.amount = this.order.totals.tip
      this.showCustom = true
      this.customApplied = true
    }
    if (this.order.totals.tip == 0) {
      this.setAmount(.15)
    }
  },
  methods: {
    setAmount(v) {
      this.selected = v
      if (v == 'custom') {
        // this.amount = null
        this.showCustom = true
      } else {
        this.showCustom = false
        this.amount = parseFloat((this.order.totals.subtotal * v).toFixed(2))
        this.setTip()
      }
    },
    async setTip() {
      this.$api.addTip(this.amount)
      if (this.showCustom) {
        this.customApplied = true
      }
    }
  }
}
